/**
 * Get an environment variable from Vite's import.meta.env
 * This function converts REACT_APP_ prefixed variable names to VITE_ prefix
 * for backwards compatibility during the CRA to Vite migration.
 */
export const findEnvAttr = (attr: string): any => {
	// Convert REACT_APP_ prefix to VITE_ prefix for backwards compatibility
	const viteAttr = attr.replace('REACT_APP_', 'VITE_');
	return (import.meta.env as any)[viteAttr];
};
